import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createPortal } from "react-dom";

import { useCompanionModalContainer } from "./CompanionModalContainerContext";

export default function CompanionModal({ title, children, onClose }) {
  const contextContainer = useCompanionModalContainer();
  const target = contextContainer ?? document.body;

  if (!target) {
    return null;
  }

  return createPortal(
    <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-black/50 p-6">
      <div
        className="bg-white rounded-lg p-4 text-center shadow-xl space-y-3"
        data-testid="companion-modal"
      >
        <div className="flex justify-end">
          <button onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <h1 className="text-2xl font-bold dark:text-gray-700">
          {title}
        </h1>
        <div>{children}</div>
      </div>
    </div>,
    target,
  );
}
